import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

export function showUpgradePlanRequired(
  entities: IEntitiesStore,
  {
    onFailed,
    useFor,
  }: {
    onFailed: () => void
    useFor: string
  }
) {
  const { usersStore } = entities
  const id = nanoid()

  const onClose = () => {
    onFailed()
    modalStore.removeModal(id)
  }

  const title = 'Upgrade to unlock'

  if (usersStore.user?.isAdminOrOwnerRole) {
    modalStore.addModal({
      id,
      type: ModalTypeList.INFO,
      title,
      desc: `To use ${useFor}, upgrade your plan`,
      primaryAction: {
        onAction: async () => {
          window.open(`/${BillingPath.upgrade}`, '_blank')
          onClose()
        },
        text: 'Upgrade plan',
      },
      closeActionButtonProps: {
        text: 'Cancel',
        contained: 'secondary',
      },
      onClose,
    })
  } else {
    modalStore.addModal({
      id,
      type: ModalTypeList.INFO,
      title,
      desc: `To use ${useFor}, ask one of your admins to upgrade`,
      onClose,
    })
  }
}
